
































import { computed, defineComponent, PropType } from "@vue/composition-api";
import {
  FundraisingGoalReward,
  FundraisingGoalRewardStatus,
  InputFundraisingGoalRewardCreate,
} from "@scrile/api-provider/dist/api/FundraisingGoalsProvider";
import useBlobUrl from "@/hooks/useBlobUrl";
import { $t, $tc } from "@/lib/i18nHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { QuickTip } from "@/types";
import BaseChip from "@/components/BaseChip";
import BaseIcon from "@/components/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import BaseImage from "@/components/BaseImage/BaseImage";
import FormatMoney from "@/components/FormatMoney";
import QuickTipsItem from "@/components/QuickTipsItem";

const tipItemsMap: Record<string, QuickTip> = {
  [FundraisingGoalRewardStatus.NEW]: {
    icon: "sci-progress-check",
    type: "info",
    text: $t("This reward is being verified"),
  },
  [FundraisingGoalRewardStatus.DECLINED]: {
    icon: "sci-information-triangle",
    type: "warning",
    text: $t("Decline reason was not provided"),
  },
  [FundraisingGoalRewardStatus.DELETED]: {
    icon: "sci-trash-outline",
    type: "warning",
    text: $t("Reward deleted"),
  },
};

export default defineComponent({
  name: "FundraisingGoalRewardCard",
  components: {
    QuickTipsItem,
    BaseIconButton,
    BaseIcon,
    FormatMoney,
    BaseChip,
    BaseImage,
  },
  props: {
    reward: {
      type: Object as PropType<FundraisingGoalReward | Omit<InputFundraisingGoalRewardCreate, "goalId">>,
      required: true,
    },
    file: { type: File },
    canEdit: { type: Boolean, default: false },
    canDelete: { type: Boolean, default: false },
  },
  setup(props) {
    const { getBlobUrl } = useBlobUrl();

    const coverScr = computed(() => {
      if ("file" in props.reward && props.reward.file)
        return MediaFilesController.getImageThumbnail(props.reward.file.urlPart, "720p");
      if (props.file) return getBlobUrl(props.file);
      else return "";
    });
    const countInfo = computed(() => {
      if (!props.reward.totalCount) return $t("Unlimited rewards");
      if ("id" in props.reward) {
        return $t("{0} left", [$tc($t("reward"), props.reward.totalCount - props.reward.purchasedCount)]);
      }
      return $tc($t("reward"), props.reward.totalCount);
    });

    const isDeclined = computed(
      () => "status" in props.reward && props.reward.status === FundraisingGoalRewardStatus.DECLINED
    );
    const isUnderVerification = computed(
      () => "status" in props.reward && props.reward.status === FundraisingGoalRewardStatus.NEW
    );
    const isDeleted = computed(
      () => "status" in props.reward && props.reward.status === FundraisingGoalRewardStatus.DELETED
    );
    const isActive = computed(() => !(isDeclined.value || isUnderVerification.value || isDeleted.value));

    const tipItem = computed<QuickTip | null>(() => {
      if (isActive.value || !("status" in props.reward)) return null;
      let resp = tipItemsMap[props.reward.status];
      if (isDeclined.value && "declineReason" in props.reward && props.reward.declineReason) {
        resp = { ...resp, text: props.reward.declineReason };
      }
      return resp;
    });

    return {
      coverScr,
      countInfo,
      tipItem,
      isDeleted,
      isDeclined,
      tipItemsMap,
    };
  },
});
